<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div
            class="page-title-content"
            
        >
            <h2 data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1200">Tour And Travels</h2>
            <ul data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1200">
                <li><a routerLink="/">Home</a></li>
                <li>Tour And Travels</li>
            </ul>
        </div>
    </div>
    
</div>
<!-- End Page Title Area -->

<!-- Start Educational Area -->
<!-- <div class="aboutus-hb__control_panel">
    <div class="aboutus-hb__yearline">
        <div class="aboutus-hb__yearline_track">
            <div
            class="page-heading"
            style="
                height: 150px;
                text-align: center;
                color: #000000;
                margin-bottom: 40px;
                text-transform: uppercase;
            "
        >
            <h1>
                <b
                    >Efficient Travel Solutions: Overcoming Industry Challenges with VOCBOT</b
                >
            </h1>
             
        </div>
        </div>
    </div>
     
</div> -->

<section class="team-area  ">
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <!-- <div class="col-lg-12 col-md-12 col-sm-12">
                   
                </div> -->
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/tour-destination.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Destination Assistance
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >
                        Vocbot assists users in choosing their travel destinations based on preferences by considering various factors such as interests, budget, and travel dates.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Itinerary Planning
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >
                        Users can take assistance from Vocbot to create personalised travel itineraries considering the destination's attractions, activities, and accommodations.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/a-woman-preparing.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                 
                   
                
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img  src="assets/img/traveler-get-customer.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Booking Support
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >
                        Vocbot assists customers in booking their flights and hotels by providing real-time information on availability and pricing.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Travel Information
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >
                        Vocbot can provide essential travel details such as visas, permits, and other documents.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img  src="assets/img/tour-info.png"  alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
               
                   
              
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img  src="assets/img/tour-weather.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Weather Updates
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >
                        Vocbot can provide weather updates and forecast the weather conditions of the chosen destinations.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Emergency Assistance
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >
                        Vocbot provides assistance during emergencies and offers information on the availability of services and resources.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/winter-sos-message-emergency.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
               
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/online-shop-black-friday-season-sale.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Promotions and Offers
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >
                        Vocbot assists users about the travel deals, packages, offers and ongoing promotions to plan cost-effective trips.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

   
</section>
<!-- <section class="team-area ptb-110"> 

<div
    class="page-heading"
    data-aos="fade-down"
    data-aos-easing="linear"
    data-aos-duration="1200"
    style="
        height: 150px;
        text-align: center;
        color: #000000;
        margin-bottom: 40px;
        text-transform: uppercase;
    "
>
    <h1>
        <b>Efficient Travel Solutions: Overcoming Industry Challenges with VOCBOT</b>
    </h1>
    <img src="assets/img/RO.gif" style="height: 35px" />
</div>

<div class="container-fluid"  >
    <div class="row">

        <div class="row member-content">
            <div class="col-lg-12 col-md-12">

               
                <div class="row row-margin-1" data-aos="zoom-in">
                    <div class="col-sm-12 col-md-4  col-lg-4 member-thumb-1 ">
                        <img  src="assets/img/tour-destination.png" class="rounded-circle" alt="">
                       
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-8 mobile-content">
                        <div class="details-1" data-aos="fade-right"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine">
                        
                            <p class="title mb-2">Destination Assistance</p>
                            
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2"> Vocbot  assist users in choosing travel destinations based on
                                preferences. They consider factors such as interests,
                                budget, and travel dates.</p>
                        </div>
                    </div>
                </div>
 

    
                <div class="row row-margin-2 mobile-margin-top" data-aos="zoom-in">
                    
                    <div class="col-sm-12 col-lg-8 order-lg-1 order-sm-2 order-xs-2 order-2 mobile-content">
                        <div class="details-2" data-aos="fade-left"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine " >
                            <p class="title mb-2">Itinerary Planning</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2"> Users interact with Vocbot  to create personalized travel
                                itineraries. Chatbots suggest activities, attractions, and
                                accommodations.</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-4 member-thumb-2 order-lg-2  order-sm-1 order-xs-1 order-1 ">
                        <img  src="assets/img/tour-planning.png" class="rounded-circle" alt="">
                       
                    </div>
                </div>

   
                <div class="row row-margin-1  mobile-margin-top" data-aos="zoom-in">
                    <div class="col-sm-12 col-lg-4 member-thumb-1  ">
                        <img src="assets/img/tour-booking.png" class="rounded-circle" alt="">
                       
                    </div>
                    <div class="col-sm-12 col-lg-8  mobile-content">
                        <div class="details-1" data-aos="fade-right"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine">
                            <p class="title mb-2">Booking Support</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2">Vocbot  facilitate bookings for flights, hotels, and other
                                services. They provide real-time information on availability
                                and pricing.</p>
                        </div>
                    </div>
                </div>

                

    
                <div class="row row-margin-2 mobile-margin-top" data-aos="zoom-in">
                    
                    <div class="col-sm-12 col-lg-8 order-lg-1 order-lg-2  order-sm-2 order-xs-2 order-2 mobile-content ">
                        <div class="details-2" data-aos="fade-left"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine " >
                            <p class="title mb-2">Travel Information</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2">Vocbot  offer details on travel documentation requirements.
                                They provide information on visas, permits, and other
                                essential documents.</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-4 member-thumb-2 order-lg-2 order-lg-1 order-sm-1 order-xs-1 order-1 ">
                        <img   src="assets/img/tour-info.png" class="rounded-circle" alt="">
                       
                    </div>
                </div>

 
                <div class="row row-margin-1 mobile-margin-top" data-aos="zoom-in">
                    <div class="col-sm-12 col-lg-4 member-thumb-1 order-lg-2 order-lg-1 order-sm-1 order-xs-1 order-1  ">
                        <img src="assets/img/tour-weather.png" class="rounded-circle" alt="">
                       
                    </div>
                    <div class="col-sm-12 col-lg-8 order-lg-1 order-lg-2  order-sm-2 order-xs-2 order-2 mobile-content">
                        <div class="details-1" data-aos="fade-right"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine">
                            <p class="title mb-2">Weather Updates</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2"> Users can inquire about current and forecasted weather
                                conditions. Vocbot  deliver timely weather updates for chosen
                                destinations.</p>
                        </div>
                    </div>
                </div>

             

    
                <div class="row row-margin-2 mobile-margin-top " data-aos="zoom-in">
                    
                    <div class="col-sm-12 col-lg-8 order-lg-1 order-sm-2 order-xs-2 order-2 mobile-content">
                        <div class="details-2" data-aos="fade-left"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine " >
                            <p class="title mb-2">Emergency Assistance</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2">Vocbot  provide guidance in case of emergencies or unexpected
                                events. They offer information on local emergency services
                                and resources.</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-4 member-thumb-2 order-lg-2 order-lg-1 order-sm-1 order-xs-1 order-1 function-image  ">
                        <img src="assets/img/tour-sos.png" class="rounded-circle" alt="">
                       
                    </div>
                </div>

                <div class="row row-margin-1 mobile-margin-top" data-aos="zoom-in">
                    <div class="col-sm-12 col-lg-4 member-thumb-1 order-lg-1 order-sm-1 order-xs-1 order-1  function-image">
                        <img src="assets/img/tour-offer.png" class="rounded-circle" alt="">
                       
                    </div>
                    <div class="col-sm-12 col-lg-8 order-sm-2 order-xs-2 order-2 mobile-content">
                        <div class="details-1" data-aos="fade-right"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine">
                            <p class="title mb-2">Promotions and Offers</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2"> Vocbot  inform users about travel deals, discounts, and
                                promotions. They guide users on how to take advantage of
                                special offers for a cost-effective trip.</p>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    
    </div>
</div>
</section> -->


<!-- Start Educational Area -->
<!-- <section class="features-area ptb-110"> -->
<!-- <div class="container-fluid">
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div
                class="image wow zoomIn"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <img
                    style="max-width: 60%"
                    src="assets/img/tour-destination.png"
                    alt="image"
                />
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div
                class="content"
                data-Aos="fade-left"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
            >
                <h3><b>Destination Assistance</b></h3>
                <img src="assets/img/RO.gif" style="height: 20px" />
                <p>
                    Vocbot  assist users in choosing travel destinations based on
                    preferences. They consider factors such as interests,
                    budget, and travel dates.
                </p>
            </div>
        </div>
    </div>
</div>

<div
    class="container-fluid"
    style="background-image: url(assets/img/corner.jpg); background-size: cover"
>
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 order-lg-1 order-2">
            <div
                class="content"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <h3><b>Itinerary Planning</b></h3>
                <img src="assets/img/RO.gif" style="height: 20px" />
                <p>
                    Users interact with Vocbot  to create personalized travel
                    itineraries. Chatbots suggest activities, attractions, and
                    accommodations.
                </p>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 order-lg-2 order-1">
            <div
                class="image wow zoomIn"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <img
                    style="max-width: 60%"
                    src="assets/img/tour-planning.png"
                    alt="image"
                />
            </div>
        </div>
    </div>
</div>
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div
                class="image wow zoomIn"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <img
                    style="max-width: 60%"
                    src="assets/img/tour-booking.png"
                    alt="image"
                />
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div
                class="content"
                data-Aos="fade-left"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
            >
                <h3><b>Booking Support</b></h3>
                <img src="assets/img/RO.gif" style="height: 20px" />
                <p>
                    Vocbot  facilitate bookings for flights, hotels, and other
                    services. They provide real-time information on availability
                    and pricing.
                </p>
            </div>
        </div>
    </div>
</div>

<div
    class="container-fluid"
    style="background-image: url(assets/img/corner.jpg); background-size: cover"
>
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 order-lg-1 order-2">
            <div
                class="content"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <h3><b>Travel Information</b></h3>
                <img src="assets/img/RO.gif" style="height: 20px" />
                <p>
                    Vocbot  offer details on travel documentation requirements.
                    They provide information on visas, permits, and other
                    essential documents.
                </p>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 order-lg-2 order-1">
            <div
                class="image wow zoomIn"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <img
                    style="max-width: 60%"
                    src="assets/img/tour-info.png"
                    alt="image"
                />
            </div>
        </div>
    </div>
</div>
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div
                class="image wow zoomIn"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <img
                    style="max-width: 60%"
                    src="assets/img/tour-weather.png"
                    alt="image"
                />
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div
                class="content"
                data-Aos="fade-left"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
            >
                <h3><b>Weather Updates</b></h3>
                <img src="assets/img/RO.gif" style="height: 20px" />
                <p>
                    Users can inquire about current and forecasted weather
                    conditions. Vocbot  deliver timely weather updates for chosen
                    destinations.
                </p>
            </div>
        </div>
    </div>
</div>

<div
    class="container-fluid"
    style="background-image: url(assets/img/corner.jpg); background-size: cover"
>
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 order-lg-1 order-2">
            <div
                class="content"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <h3><b>Emergency Assistance</b></h3>
                <img src="assets/img/RO.gif" style="height: 20px" />
                <p>
                    Vocbot  provide guidance in case of emergencies or unexpected
                    events. They offer information on local emergency services
                    and resources.
                </p>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 order-lg-2 order-1">
            <div
                class="image wow zoomIn"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <img
                    style="max-width: 60%"
                    src="assets/img/tour-sos.png"
                    alt="image"
                />
            </div>
        </div>
    </div>
</div>
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div
                class="image wow zoomIn"
                data-aos="fade-up"
                data-aos-anchor-placement="bottom-bottom"
            >
                <img
                    style="max-width: 60%"
                    src="assets/img/tour-offer.png"
                    alt="image"
                />
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div
                class="content"
                data-Aos="fade-left"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
            >
                <h3><b>Promotions and Offers</b></h3>
                <img src="assets/img/RO.gif" style="height: 20px" />
                <p>
                    Vocbot  inform users about travel deals, discounts, and
                    promotions. They guide users on how to take advantage of
                    special offers for a cost-effective trip.
                </p>
            </div>
        </div>
    </div>
</div>

<div class="rectangle-shape1" data-aos="zoom-in">
    <img src="assets/img/rectangle-shape1.png" alt="image" />
</div>
<div class="rectangle-shape2" data-aos="zoom-in">
    <img src="assets/img/rectangle-shape2.png" alt="image" />
</div> -->
